import reactComponentLoader from 'scripts/react-component-loader'

import FamilyPage from './FamilyPage'

reactComponentLoader(FamilyPage, '[data-family-page]')
